module.exports = "pegasus_template/assets/blocks/column-4-theme6.png";